module.exports = __webpack_public_path__ + "static/media/frown-open.7d8516be.svg";